<template>
  <ul name="el-list" class="clearfix">
    <li class="item" v-for="(file, index) in fileList" :key="file.url + '-' + index">
      <div class="wrapper">
        <img v-if="!file.type" class="thumbnail" :src="file.url" alt />
        <div class="not-img" v-else>
          <span>{{ file.type }}</span>
        </div>
        <span class="action" :class="{ is_disabled: disabled }">
          <span v-if="!preview">
            <i class="el-icon-delete" @click="deleteFile(file)"></i>
          </span>
          <span v-if="preview && !file.type">
            <i class="el-icon-view" @click="previewFile(file)"></i>
          </span>
          <span v-if="file.type">
            <i class="el-icon-download" @click="downloadFile(file)"></i>
          </span>
        </span>
        <div id="zg-upload-item-box" class="progress" v-if="file.status === 'ready'">
          <div class="progress-content">
            <p class="text">{{ file.percentage }}%</p>
            <el-progress
              :percentage="file.percentage"
              :show-text="false"
              color="#ffffff"
            ></el-progress>
          </div>
        </div>
      </div>
      <p v-if="file.name" class="name">{{ file.name }}</p>
    </li>
    <li v-if="!preview" key="upload" class="item" :class="{ is_disabled: disabled }">
      <el-upload action="#" :auto-upload="false" :show-file-list="false" :on-change="handleChange">
        <div class="el-upload--picture-card">
          <i slot="default" class="el-icon-plus"></i>
        </div>
      </el-upload>
    </li>
  </ul>
</template>

<script>
import { uploadFile } from '@/common/services/upload'
import preview from '@/common/utils/preview'
import { download } from '@/common/utils/download'

export default {
  name: 'UploadList',
  props: {
    limit: Number,
    disabled: Boolean,
    extraParams: Object,
    accept: {
      type: String,
      default: 'image/jpg, image/jpeg, image/png'
    },
    preview: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      fileList: []
    }
  },
  methods: {
    downloadFile(file) {
      download(file.url)
    },
    previewFile(file) {
      preview.previewImage([file.url])
    },
    handleChange(file) {
      try {
        if (this.accept.indexOf(file.raw.type.toLowerCase()) === -1) {
          this.$message.error(`图片类型只支持 ${this.accept}`)
          return
        }

        if (this.limit && this.fileList.length >= this.limit) {
          this.$message.warning(`最多上传${this.limit}个文件`)
          return
        }
        file.loading = true
        file.url = URL.createObjectURL(file.raw)
        this.fileList.unshift(file)
        uploadFile(file, {
          isPrivate: true,
          extraParam: this.extraParams,
          onProgress: progress => {
            file.percentage = Math.round((progress.loaded / progress.total) * 100)
          }
        })
          .then(result => {
            file.fk = result
            file.status = 'success'
          })
          .catch(() => {
            this.deleteFile(file)
          })
      } catch (err) {
        console.error('upload error:', err)
      }
    },
    deleteFile(file) {
      const index = this.fileList.indexOf(file)
      if (index !== -1) {
        this.fileList.splice(index, 1)
      }
    },
    getFileList() {
      return this.fileList
    },
    reset() {
      this.fileList = []
    },
    setFileList(files) {
      this.fileList = files
    }
  },
  beforeDestroy() {
    preview.previewDestroy()
  }
}
</script>

<style>
#zg-upload-item-box .el-progress-bar__outer {
  background: rgba(255, 255, 255, 0.36);
}
</style>

<style lang="less" scoped>
.item {
  float: left;
  width: 148px;
  overflow: hidden;
  margin-right: 8px;
  margin-top: 8px;

  .wrapper {
    position: relative;
    width: 148px;
    height: 148px;

    .thumbnail {
      width: 100%;
      height: 100%;
    }

    .progress {
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      cursor: default;
      background-color: rgba(0, 0, 0, 0.5);
      transition: opacity 0.3s;
      .progress-content {
        position: absolute;
        top: 50%;
        left: 12px;
        right: 12px;
        text-align: center;
        transform: translateY(-50%);
        .text {
          color: #ffffff;
        }
      }
    }

    .action {
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      cursor: default;
      text-align: center;
      color: #fff;
      opacity: 0;
      font-size: 20px;
      background-color: rgba(0, 0, 0, 0.5);
      transition: opacity 0.3s;

      &::after {
        display: inline-block;
        content: '';
        height: 100%;
        vertical-align: middle;
      }

      span {
        display: none;
        cursor: pointer;
      }

      &:hover {
        opacity: 1;
        span {
          display: inline-block;
        }
      }
    }
  }

  .name {
    font-size: 12px;
    font-weight: 400;
    color: rgba(102, 102, 102, 1);
    line-height: 13px;
    text-align: center;
    margin-top: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
.is_disabled {
  display: none;
}
.not-img {
  width: 100%;
  height: 100%;
  line-height: 148px;
  background: #f5f7fa;
  text-align: center;
  font-size: 26px;
  color: #303030;
}
</style>
